import moment from "moment";
import _ from "underscore";
import "../momentHolidays";
import merge from "deepmerge";


export {merge};

export function isTruthy(val){
  return val === "true" || val === true;
}

export function isFalsey(val){
  return val === "false" || val === false;
}

export function isPresent(val){
  return !_.isUndefined(val) && !_.isNull(val) && val !== "";
}

export function isBlank(val){
  return _.isUndefined(val) || _.isNull(val) || val === "";
}

export function isGtZero(val){
  return val > 0;
}

export function toWeekDayMonthAndDay(val){
  return moment(val, "MM/DD/YYYY").format("dddd, MMMM Do");
}

export function convertMilitaryToInt(time){
  const mmt = moment(time, 'HH:mm').format('HHmm');
  return parseInt(mmt, 10);
}

export function militaryToPeriodTime(time){
  return moment(time, 'HH:mm').format('h:mm A');
}

export function getHoliday(str, {pattern="MM/DD/YYYY", includes, holidayLookup}={}){
  return moment(str, pattern).holiday({includes, holidayLookup});
}

export function getWeekend(str, {pattern="MM/DD/YYYY"}={}){
  const day = moment(str, pattern).day();
  return day == 6 || day == 0;
}

export function isDaylightSavingsTimeInEffect(date){
  return date.getTimezoneOffset() < stdTimezoneOffset(date);
}

export function stdTimezoneOffset(date){
   const jan = new Date(date.getFullYear(), 0, 1);
   const jul = new Date(date.getFullYear(), 6, 1);
   return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}

export function rgxTest(rgx, str){
  return rgx.test(str);
}

// This function is used to check if a given key
// in an object exists AND equals false, in order
// to explicitly return false as the default option,
// other wise return true
export function keyDefaultFalseOption(obj, key){
  if(_(obj).has(key) && !obj[key]){
    return false
  }
  else{
    return true
  }
}

export function removeAmpersand(e) {
  $(this).val($(this).val().replace(/&/g, ""));
}

export function removeNonDigit(e) {
  $(this).val($(this).val().replace(/[^0-9]+/g, ""));
}


export function createPreventDefault(func){
  return (e)=>{
    e.preventDefault()
    func();
  }
}

export function formateDateUtil(createdDate, type, data){
  if(createdDate != null && createdDate != ""){
    var date = new Date(createdDate); //createdDate is long time format
    var month = date.getMonth() + 1;
    var today = new Date();
    var oneDay = 24*60*60*1000;
    today.setHours(0,0,0,0);
    date.setHours(0,0,0,0);
    var diffDays = Math.floor(Math.abs((today.getTime() - date.getTime())/(oneDay)));
    var friendlyText = "";
    var datePillHTML  = ""
    if(diffDays < 100){
      friendlyText = diffDays.toString() + ' Days Ago';
      datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
    }
    if(diffDays == 0){
      friendlyText = 'Today';
    }else if(diffDays== 1){
      friendlyText ='Yesterday'
    }
    return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
  }else{
    return "";
  }
}

export function shallAllowClick(currentObj){
  return 	!($(currentObj).hasClass("disabled"));
}

export function getMilitaryTimeFromDate(date) {
  return `${date.getHours()}:${date.getMinutes()}`;
}

export function fuseDateTimeValueToStandard(date, time){
  let dateString = `${date} ${time}`;
  return new Date(dateString);
}

export function getESTDate(date){
  //EST
  let offset = 0;
  if (isDaylightSavingsTimeInEffect(date)) { //check time zone for given date
    offset = -4.0;
  }else{
    offset = -5.0;
  }
  let utc = date.getTime() + (date.getTimezoneOffset() * 60000);
  date = new Date(utc + (3600000*offset));
  return date;
}

export function formatPhone(phoneNumberString){ //+1 (420) 234-2347
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/(\d{1,3})?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      var intlCode = (match[1] ? '+'+match[1] : '')
      return   [intlCode, ' (', match[2], ') ', match[3], '-', match[4]].join('')
    }
    return null;

}


// WEBPACK FOOTER //
// ./src/utilities/general/index.js